import React from 'react';

const paths: Record<string, string[]> = {
  dashboard: ['M3 3h7v7H3zM14 3h7v7h-7zM3 14h7v7H3zM14 14h7v7h-7z'],
  document: ['M6 3h8l4 4v14H6z', 'M14 3v5h4M9 12h6M9 16h6'],
  checklist: ['M9 5h11M9 12h11M9 19h11', 'm3 5 1 1 2-2m-3 8 1 1 2-2m-3 8 1 1 2-2'],
  people: ['M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M19 15a4 4 0 0 1 3 4v2', 'M9 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8M17 3a4 4 0 0 1 0 8'],
  shield: ['M12 3 3 7v5c0 5 9 10 9 10s9-5 9-10V7z', 'M12 8v5M12 17h.01'],
  building: ['M4 21V3h12v18M16 9h4v12M2 21h20M8 7h4M8 11h4M8 15h4M9 21v-3h3v3'],
  register: ['M4 3h16v18H4zM4 9h16M9 9v12M13 13h4M13 17h4'],
  layers: ['m12 3 10 5-10 5L2 8z', 'm2 12 10 5 10-5M2 16l10 5 10-5'],
  calendar: ['M4 5h16v16H4zM4 10h16M8 3v4M16 3v4M8 14h2M14 14h2M8 17h2'],
  leaf: ['M20 3c0 9-3 16-10 16a6 6 0 0 1-6-6c0-7 8-10 16-10Z', 'M3 21 15 9'],
  folder: ['M3 6h7l2 3h9v12H3zM3 6V3h7l2 3h6v3'],
  chart: ['M3 3v18h18M8 17v-5M13 17V7M18 17v-9'],
  archive: ['M3 3h18v5H3zM5 8v13h14V8M10 12h4'],
};

const IntegratedManagementIcon: React.FC<{ name: string }> = ({ name }) => <svg className="ims-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
  {(paths[name] || paths.document).map((path, index) => <path key={index} d={path} />)}
</svg>;

export default IntegratedManagementIcon;
